import { useIsFetching, useQuery } from "@tanstack/vue-query";
import { computed } from "vue";

import { getReceipts } from "@/api";
import { useSessionExpiredStore } from "@/stores/useSessionExpiredStore";

export function useReceipts() {
  const isLoginFetching = useIsFetching({ queryKey: ["login"] });
  return useQuery({
    queryKey: ["receipts"],
    queryFn: async () => {
      const { response, data, error } = await getReceipts();

      if (response.status === 403) {
        useSessionExpiredStore().setSessionExpired(true);
      }

      if (error) {
        throw error;
      }

      return data;
    },
    staleTime: 1000 * 60 * 1, // 1 minutes
    enabled: computed(() => isLoginFetching.value === 0),
  });
}
